module.exports = __webpack_public_path__ + "static/media/img_features_02.45ef63c9.jpg";